
	import { defineComponent, onMounted } from "vue";
	import userService from "../services/users";

	export default defineComponent({
		setup() {
			const { avengers, assembleAvengers } = userService();

			onMounted(() => {
				assembleAvengers();
			});

			return { avengers, assembleAvengers };
		},
	});
